"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.mergeState = undefined;

var _extends2 = require("babel-runtime/helpers/extends");

var _extends3 = _interopRequireDefault(_extends2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// eslint-disable-next-line no-underscore-dangle
global.__redux_recompose_merge = function (state, content) {
  return (0, _extends3.default)({}, state, content);
};
// global.__redux_recompose_merge = (state, content) => state.merge(content);


// This will be exported as configureMergeState at main file

exports.default = function (modifier) {
  // eslint-disable-next-line no-underscore-dangle
  global.__redux_recompose_merge = modifier;
};

// eslint-disable-next-line no-underscore-dangle


var mergeState = exports.mergeState = function mergeState(state, content) {
  return global.__redux_recompose_merge(state, content);
};